export type CapacityLevel = "GREEN" | "YELLOW" | "RED";

/**
 * Canonical occupancy → traffic-light mapping for Resto.
 *
 *   < 60%        → GREEN  (wide open)
 *   60–90%       → YELLOW (filling up)   — inclusive at 60, exclusive at 90
 *   > 90%        → RED    (at capacity)  — strict "more than 90%"
 *
 * One source of truth — every slider/chip/store derivation calls this.
 */
export const YELLOW_AT = 0.6;
export const RED_AT = 0.9;

/**
 * Discreet mode (`pos_explicit = false`, Teo Oct 14): the card's slider shows
 * roughly how full the room is, snapped to whole tables, with no numbers, and
 * never below a quarter, so a quiet room never reads as empty.
 */
export const DISCREET_TABLE_SEATS = 4;
export const DISCREET_MIN_FILL = 0.25;

/** Seats the discreet slider fills to: occupancy snapped to tables, floored at 25%. */
export function discreetFill(occupied: number, capacity: number): number {
  const cap = Math.max(capacity, 1);
  const snapped = Math.round(occupied / DISCREET_TABLE_SEATS) * DISCREET_TABLE_SEATS;
  return Math.min(cap, Math.max(snapped, Math.ceil(cap * DISCREET_MIN_FILL)));
}

export function deriveCapacityLevel(occupied: number, capacity: number): CapacityLevel {
  const ratio = occupied / Math.max(capacity, 1);
  if (ratio > RED_AT) return "RED";
  if (ratio >= YELLOW_AT) return "YELLOW";
  return "GREEN";
}
